import { PureComponent, createRef } from 'react';
import { Container } from 'reactstrap';
import { withMobileAppMode } from '@front-activerse/common-components';

const DAY_COUNT = 23;
const DEFAULT_ITEM_COUNT = 7;
const DEFAULT_ITEM_COUNT_DESKTOP = 19;
const ITEM_WIDTH_PX = 40;
const MAX_SCREEN_WIDTH = 1000;

const calcItemMargin = (screenWidth) => {
  const screenWidthToUse = screenWidth > MAX_SCREEN_WIDTH ? MAX_SCREEN_WIDTH : screenWidth;
  let itemCount = DEFAULT_ITEM_COUNT;

  if (screenWidthToUse > 575) {
    itemCount = DEFAULT_ITEM_COUNT_DESKTOP;
  }

  const divisor = itemCount + 1;
  const margin = (screenWidthToUse - itemCount * ITEM_WIDTH_PX) / divisor;

  if (margin < 0) {
    return -margin;
  } else {
    return margin;
  }
};
const MIDDLE_INDEX = Math.floor(DAY_COUNT / 2);

class TimelinePlaceholder extends PureComponent {
  middleItemRef = createRef();

  state = {
    screenWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
  };

  componentDidMount() {
    this.scrollToMiddle();
    this.resizeHandler = () => {
      this.setState({ screenWidth: window.innerWidth });
      this.scrollToMiddle();
    };
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillUnmount() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  scrollToMiddle = () => {
    const el = this.middleItemRef.current;
    if (el) {
      el.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
    }
  };

  repeat = (times, func) => {
    const result = [];
    for (let i = 0; i < times; i += 1) {
      result.push(func(i));
    }
    return result;
  };

  render() {
    const itemMargin = calcItemMargin(this.state.screenWidth);

    return (
      <div className="timeline-container hidden">
        <section className="timeline placeholder-glow">
          <Container>
            <nav>
              <div className="timeline-arrow left opacity-25">
                <span className="SVGInline">{this.props.leftArrow}</span>
              </div>
              <div className="timeline-arrow right opacity-25">
                <span className="SVGInline">{this.props.rightArrow}</span>
              </div>

              <ul>
                {this.repeat(DAY_COUNT, (key) => (
                  <li
                    className="nav-item"
                    key={key}
                    ref={key === MIDDLE_INDEX ? this.middleItemRef : null}
                    style={{
                      marginLeft: itemMargin,
                      ...(key === DAY_COUNT - 1 && { marginRight: itemMargin }),
                    }}
                  >
                    <span className="nav-link placeholder" tabIndex="-1" role="presentation">
                      &nbsp; <br />
                      &nbsp;
                    </span>
                  </li>
                ))}
              </ul>
            </nav>
          </Container>
        </section>
      </div>
    );
  }
}

export { TimelinePlaceholder };
export default withMobileAppMode(TimelinePlaceholder);
